<template>
  <div class="w-full h-full" v-loading="loadingEngine">
    <img
      id="playerEngineId"
      class="h-full w-full engineVideo"
      v-if="modelSetting.cloudRenderLoadMode === 'img'"
    />
    <video id="playerEngineId" autoplay playsinline muted class="engineVideo w-full" v-else></video>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>

<script>
import { instance as cloudRender } from 'wiz-cloud-render'
import { loadSceneFromJson, isJSONObj, getNodesByNodeType } from '../../assets/js/scene/scene'
import downloadFile from '../../assets/js/model/modelDownload'

const PlayerProgress = () => {
  return import('./PlayerProgress')
}
export default {
  name: 'ModelView',
  components: { PlayerProgress },
  props: {
    loadModelType: {
      type: String,
      defalut: 'modelFileId',
    },
    sceneOptions: {
      type: Object,
      defalut: () => {
        return {
          isEnableGis: false,
          latitude: 0,
          longitude: 0,
          name: '',
          id: '',
          folderId: '',
          jsonData: '',
        }
      },
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        }
      },
    },
  },
  data() {
    return {
      player: null, // player实例

      loadingEngine: false, // 引擎加载状态
      showLoadProgress: false, // 进度条显隐
      loadType: '', // 进度条类型
      loadPercentage: 0, // 进度条值
      sceneFileList: [],
      fileCount: 0,
      sceneData: {},
      sceneRootNode: 0,
      loadedModels: [],
      loadedNodes: [],
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 云渲染协议
    cloundProtocol() {
      return this.modelSetting.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloundServerPath() {
      return this.modelSetting.cloudServerPath || '192.168.20.79:8082'
    },
    // 模型文件
    modelFileList() {
      return this.modelSetting.modelFileList || []
    },
  },
  watch: {
    sceneOptions: {
      async handler(data) {
        if (this.player) {
          if (data.longitude && data.latitude) {
            this.moveToLLH(data.longitude, data.latitude)
            const elevation = (
              await this.player.Native.GisPlatform.queryDEM([[data.longitude, data.latitude, 0]])
            )[0]
            const rootItem = await this.player.Native.ModelTree.getRootItems()
            // 在跟节点集合中查找我们设置的场景的跟节点
            const rootNode = _.find(rootItem, (val) => {
              return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
            })
            if (rootNode) {
              const rootInfo = JSON.parse(rootNode.code)
              this.player.Native.NodeProxy.setNodeGisPos(rootNode.nodePtr, [
                data.longitude,
                data.latitude,
                elevation,
              ])
              rootInfo.isEnableGis = true
              this.player.Native.NodeProxy.setNodeInfo(rootNode.nodePtr, {
                code: JSON.stringify(rootInfo),
              })
            }
          }
          const list = _.uniqBy(this.loadedNodes, 'nodePtr')
          const item = list.find((o) => {
            return o.type === 'Root'
          })
          if (item && item.nodePtr) {
            await this.player.Native.NodeProxy.destroyNode(item.nodePtr)
          }
          this.loadedNodes = []
          this.initPlayer()
        }
      },
      deep: true,
    },
    async fileCount(num) {
      if (num === 0) {
        return
      }
      if (num >= this.sceneFileList.length) {
        this.loadType = '加载中...'
        this.showLoadProgress = true
        const nodeList = await loadSceneFromJson(
          this.sceneData,
          this.sceneRootNode,
          this.player,
          this.sceneOptions,
          [],
          this.loadNodeCallback
        )
        this.fileCount = 0
        if (this.sceneData.cameraParams && isJSONObj(this.sceneData.cameraParams)) {
          const { eye, target, up } = JSON.parse(this.sceneData.cameraParams)
          await this.player.Native.Camera.moveTo(eye, target, up, 2)
        } else if (this.sceneOptions.isEnableGis) {
          await this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
        } else {
          const currentNodes = _.map(_.filter(nodeList, ['type', 'modelFile']), 'nodePtr')
          await this.moveToScene(currentNodes)
        }
        this.$emit('loadModelEnd')
        this.showLoadProgress = false
        this.loadPercentage = 0
        this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
        // this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
      } else {
        this.checkTextureFile(this.sceneFileList[num])
      }
    },
  },
  mounted() {
    //   window.addEventListener('CloudRender', async (e) => {
    //     const res = e.detail
    //     if (res.status && res.data && res.data.type === 'modelStatus') {
    //       switch (res.data.currentState) {
    //         case 1:
    //           this.showLoadProgress = true
    //           this.loadType = '加载中...'
    //           this.loadPercentage = _.round(res.data.data.process, 2)
    //           break
    //         case 3:
    //           this.showLoadProgress = true
    //           this.loadType = '下载中...'
    //           this.loadPercentage = _.round(res.data.data.process, 2)
    //           break
    //         case 4:
    //           this.showLoadProgress = false
    //           this.loadType = ''
    //           this.loadPercentage = 0
    //           this.$emit('loadModelEnd')
    //           break
    //         case 5:
    //           this.showLoadProgress = false
    //           this.loadType = ''
    //           this.loadPercentage = 0
    //           break
    //         default:
    //           break
    //       }
    //     } else if (!res.status) {
    //       this.$message.warning(res.message)
    //       this.showLoadProgress = false
    //       this.loadType = ''
    //       this.loadPercentage = 0
    //     }
    //   })

    this.loadingEngine = true
    this.runPlayer()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.exit()
    }
  },
  methods: {
    // 加载进度
    loadNodeCallback(data) {
      const scenceModelList = _.filter(this.sceneFileList, (item) => {
        return (
          item.code && (item.code?.type === 'modelFile' || item.code?.type === 'dynamicEffects')
        )
      })
      console.log(data, 'rtgrdgb')

      const loadNodes = _.filter(data, (item) => {
        return item.type === 'modelFile' || item.type === 'dynamicEffects'
      })
      this.loadedNodes.push(...data)
      if (loadNodes.length <= scenceModelList.length) {
        this.loadPercentage = _.round((loadNodes.length / scenceModelList.length) * 100, 2)
      }
    },
    // 获取场景aabb
    async getSceneAabb(nodes) {
      const aabbList = []
      for (let i = 0; i < nodes.length; i += 1) {
        const item = nodes[i]
        // eslint-disable-next-line no-await-in-loop
        const aabb = await this.player.Native.NodeProxy.getAabb(item)
        if (aabb) {
          aabbList.push(aabb)
        }
      }
      const maxX = _.maxBy(aabbList, (item) => {
        return item[1][0]
      })
      const maxY = _.maxBy(aabbList, (item) => {
        return item[1][1]
      })
      const maxZ = _.maxBy(aabbList, (item) => {
        return item[1][2]
      })
      const minX = _.minBy(aabbList, (item) => {
        return item[0][0]
      })
      const minY = _.minBy(aabbList, (item) => {
        return item[0][1]
      })
      const minZ = _.minBy(aabbList, (item) => {
        return item[0][2]
      })
      return {
        max: [maxX[1][0], maxY[1][1], maxZ[1][2]],
        min: [minX[0][0], minY[0][1], minZ[0][2]],
      }
    },
    // 移动相机到模型
    async moveToScene(nodes, face) {
      const modelAabb = await this.getSceneAabb(nodes)
      const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      await this.player.Native.Camera.addMoveToAabb(modelAabb, mat, face, 1.5, 2)
    },
    // 加载player引擎
    async runPlayer() {
      const { data } = await cloudRender.Engine.loadEngine({
        signalServer: `${this.cloundProtocol}://${this.cloundServerPath}`,
        options: {
          // openDebug: true,
          DomType: this.modelSetting.cloudRenderLoadMode === 'img' ? 1 : 0,
          videoDom: document.getElementById('playerEngineId'), // 绑定视频标签
          imgDom: document.getElementById('playerEngineId'), // 绑定视频标签
          userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
          exitTimeout: 1000 * 60 * 1, // 用户超时后多久断开会话
          maxTimeout: 1000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
        },
      })
      this.player = data.getDataInfo()

      // 实例化完成将实例化后的player传出去
      this.$emit('sendPlayer', this.player)
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      // this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      this.initPlayer()
    },
    checkModelLoad(data, node, name) {
      const modelList = _.filter(this.sceneFileList, (item) => {
        return (
          item.code &&
          item.code?.type === 'modelFile' &&
          _.last(item.code?.filePath.split('.')) === 'pr'
        )
      })
      if (!this.showLoadProgress) {
        this.loadType = '加载中...'
        this.showLoadProgress = true
      }
      if (data >= 1) {
        this.loadedModels.push(name)
      }
      this.loadPercentage = _.round((_.uniq(this.loadedModels).length / modelList.length) * 100, 2)
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.loadPercentage = 0
    },
    // 移动相机到经纬度
    async moveToLLH(long, lat) {
      if (long && lat) {
        const elevation = (await this.player.Native.GisPlatform.queryDEM([[long, lat, 0]]))[0]
        this.player.Native.Camera.addMoveToLLH([long, lat, 20000], 0)
        this.player.Native.Camera.addMoveToLLH([long, lat, elevation + 800], 8)
      }
    },
    // 初始化player
    async initPlayer() {
      // 设置点选时其他节点半透明
      this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', '0.5')
      this.loadingEngine = false
      const settingsFileUrl = `data://../apps/${this.modelSetting.folderName}/settings.json`
      const settingsData = await this.player.Native.Settings.loadJsonString(settingsFileUrl)
      if (settingsData) {
        const defaultSettings = JSON.parse(settingsData)
        _.forEach(defaultSettings.Show, (item) => {
          this.player.Native.Settings.set(item.name, item.type, item.value)
        })
      }
      // 获取到经纬度添加地图
      if (this.sceneOptions.isEnableGis) {
        await cloudRender.GIS.loadGis(this.modelSetting.globalMapPath)
      }
      // // 点选监听
      this.player.Native.ModelTree.EventSelectItemChanged.connect(this.watchMsg)
      this.loadScene()
    },
    // 检查文件是否存在
    async checkTextureFile(data) {
      if (data && data.code && data.code.modelFileId) {
        if (data.code.materialFileId && data.code.materialFileId !== 'undefined') {
          const url = `data://../apps/${data.code.filePath.split('/')[4]}/models/${
            data.code.modelFileId
          }/${data.code.materialFileId}.zip`
          const fileInfo = {
            id: data.code.materialFileId,
            url,
            fileType: 'zip',
          }
          const apiConfig = {
            path: `${
              Wiz.GetApiClientInstance('file-management')?.basePath
            }/api/file-management/files/${data.code.materialFileId}/download`,
            method: 'GET',
            headers: {
              Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
            },
          }
          const res = await downloadFile(
            this.player,
            fileInfo,
            apiConfig,
            this.progressMsg,
            this.downloadMaterialMsg(data)
          )
          if (res.type === 0 && res.success) {
            this.checkModelFile(data)
          } else {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          }
        } else {
          this.checkModelFile(data)
        }
      }
    },
    // 检查模型是否存在
    async checkModelFile(data) {
      const fileType = _.last(data.code.filePath.split('.')) || 'pr'
      const url = data.code.filePath
      const fileInfo = {
        id: data.code.modelFileId,
        url,
        fileType,
      }
      const apiConfig = {
        path: `${Wiz.GetApiClientInstance('file-management')?.basePath}/api/file-management/files/${
          data.code.modelFileId
        }/download`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      }
      const res = await downloadFile(
        this.player,
        fileInfo,
        apiConfig,
        this.progressMsg,
        this.downloadMsg
      )
      if (res.type === 0 && res.success) {
        // 有模型就加载模型
        this.fileCount += 1
      } else {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      }
    },
    // 监听下载模型是否成功
    downloadMsg(file, err) {
      this.loadPercentage = 0
      this.showLoadProgress = false
      if (err) {
        this.$message.warning(`下载文件失败，${file}, ${err}`)
      }
      this.fileCount += 1
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(data) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载贴图文件失败，${file}, ${err}`)
        }
        setTimeout(() => {
          that.checkModelFile(data)
        }, 1500)
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    // 加载场景
    async loadScene() {
      this.sceneRootNode = await this.player.Native.NodeProxy.rootNode()
      if (this.sceneOptions.jsonData && isJSONObj(this.sceneOptions.jsonData)) {
        this.sceneData = JSON.parse(this.sceneOptions.jsonData)
        this.sceneFileList = await getNodesByNodeType(this.sceneData, [])
        if (!_.isEmpty(this.sceneFileList)) {
          this.checkTextureFile(this.sceneFileList[0])
        } else {
          this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
          await loadSceneFromJson(
            this.sceneData,
            this.sceneRootNode,
            this.player,
            this.sceneOptions,
            [],
            this.loadNodeCallback
          )
          if (this.sceneData.cameraParams && isJSONObj(this.sceneData.cameraParams)) {
            const { eye, target, up } = JSON.parse(this.sceneData.cameraParams)
            await this.player.Native.Camera.moveTo(eye, target, up, 2)
          } else if (this.sceneOptions.isEnableGis) {
            await this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
          }
        }
      } else {
        this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
        const nodePtr = await this.player.Native.NodeProxy.createNode(
          this.sceneRootNode,
          this.sceneOptions.name
        )
        this.loadedNodes.push({ nodePtr, type: 'Root' })
        if (
          this.sceneOptions.isEnableGis &&
          this.sceneOptions.longitude &&
          this.sceneOptions.latitude
        ) {
          const elevation = (
            await this.player.Native.GisPlatform.queryDEM([
              [this.sceneOptions.longitude, this.sceneOptions.latitude, 0],
            ])
          )[0]
          this.player.Native.NodeProxy.setNodeGisPos(nodePtr, [
            this.sceneOptions.longitude,
            this.sceneOptions.latitude,
            elevation,
          ])
          this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
        }
        await this.player.Native.NodeProxy.setNodeInfo(nodePtr, {
          code: JSON.stringify({
            type: 'Root',
            fileType: '',
            filePath: '',
            scene: this.sceneOptions.id,
            isEnableGis: this.sceneOptions.isEnableGis,
          }),
        })
      }
      this.$emit('loadModelEnd')
    },
    // 模型点选
    watchMsg(data) {},
  },
}
</script>

<style lang="scss" scoped>
.engineVideo {
  height: 100%;
  object-fit: fill;
  transform: rotateX(180deg);
}

::v-deep .el-loading-mask {
  background-color: transparent !important;
}
</style>
